import { useState, useRef } from 'react'
import { Button, Dialog, DialogContent, DialogTitle, TextField, Checkbox, FormControlLabel, Box, InputAdornment} from '@mui/material';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import GroupsIcon from '@mui/icons-material/Groups';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import ReactMarkdown from 'react-markdown'

import applaud from './../../../assets/home/newsfeed/applaud.png'
import broadcast from './../../../assets/home/newsfeed/broadcast.png'
import vote from './../../../assets/home/newsfeed/vote.png'
import Image from './../../../assets/home/newsfeed/profile.png'

import EditorComponent from './reactquill-editor/reactquill-editor';

const PostModel = (props: any) => {
    const { setCounter, counter, toggle, setToggle } = props;

    // console.log("count",count1)
    const [editorHtmlValue, setEditorHtmlValue] = useState<string>("");
    const [editorMarkdownValue, setEditorMarkdownValue] = useState<string>("");
    const [postPreview, setPostPreview] = useState(false)
    const [inputValues, setInputValues] = useState({});
    const [addField, setAddField] = useState(2)



    const [editPost, setEditPost] = useState("data")
    console.log(addField)
    console.log(inputValues)

    const previousCounterValue = useRef(counter)

    const onEditorContentChanged = (content: any) => {
        setEditorHtmlValue(content.html);
        setEditorMarkdownValue(content.markdown);
    };


    const addFieldHandler = () => {
        setAddField(prevCount => prevCount + 1)
    }
    const handleOnChange = (e: any) => {
        const abc: any = {};
        abc[e.target.className] = e.target.value;
        setInputValues({ ...inputValues, ...abc });
    };


    const handleClickShowPassword = ()=>{
            setAddField(prevCount => prevCount - 1)
        

    }
    // GROUP CHECKBOX SELECTION

    const [checked, setChecked] = useState([true, false]);

    const handleChange1 = (event: React.ChangeEvent<HTMLInputElement>) => {
        setChecked([event.target.checked, event.target.checked]);
    };

    const handleChange2 = (event: React.ChangeEvent<HTMLInputElement>) => {
        setChecked([event.target.checked, checked[1]]);
    };

    const handleChange3 = (event: React.ChangeEvent<HTMLInputElement>) => {
        setChecked([checked[0], event.target.checked]);
    };

    // RENDERING GROUP CHECKBOX


    const children = (
        <Box sx={{ display: 'flex', flexDirection: 'column', ml: 3 }}>
            <FormControlLabel
                label="Site"
                control={<Checkbox sx={{
                    color: "#4C0027",
                    '&.Mui-checked': {
                        color: "#4C0027",
                    },
                }} checked={checked[0]} onChange={handleChange2} />}
            />
            <FormControlLabel
                label="Department"
                control={<Checkbox sx={{
                    color: "#4C0027",
                    '&.Mui-checked': {
                        color: "#4C0027",
                    },
                }} checked={checked[1]} onChange={handleChange3} />}
            />
            <FormControlLabel
                label="Groups"
                control={<Checkbox sx={{
                    color: "#4C0027",
                    '&.Mui-checked': {
                        color: "#4C0027",
                    },
                }} checked={checked[1]} onChange={handleChange3} />}
            />
        </Box>
    );

    //RENDERING ALL MODELS AND AUDIENCE MODEL

    return (
        <>
            <Dialog
                PaperProps={{
                    style: { borderRadius: 12, boxShadow: "-8px 8px 12px rgba(76, 0, 39, 0.15)" }
                }}
                fullWidth
                maxWidth="sm"
                open={toggle}
                onClose={() => setToggle(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                {/* BROADCAST, APPLAUD, AND VOTE MODEL TITLE */}

                <DialogTitle id="alert-dialog-title" className='d-flex dialogue-title' sx={{ justifyContent: "space-between" }}>
                    <div className='d-flex justify-center '>
                        {counter == 1 ? <>
                            <img src={applaud} style={{ paddingRight: "10px", height: 24 }} alt="" />
                            <h3>Broadcast</h3>
                        </> : counter == 2 ? <>
                            <img src={broadcast} style={{ paddingRight: "10px", height: 24 }} alt="" />
                            <h3>Applaud</h3>
                        </> : counter == 3 ?
                            <>
                                <img src={vote} style={{ paddingRight: "10px", height: 24 }} alt="" />
                                <h3>Vote</h3>
                            </> : counter == 4 ?
                                <>
                                    <div className='d-flex justify-center '>
                                        <h3>Who can see your post?</h3>
                                    </div>
                                </> : counter == 5 ? <h3>Preview</h3>
                                    : null}
                    </div>
                    <Button disableRipple={true} sx={{ padding: 0, minWidth: 0 }}><CancelIcon onClick={() => setToggle(false)} sx={{
                        color: "#807D7A",
                        backgroundColor: "white",
                        borderRadius: "50%",
                        fontSize: 25
                    }} /></Button>
                </DialogTitle>

                {/* BROADCAST, APPLAUD, AND VOTE MODEL CONTENT */}

                {counter != 4 && counter != 5 ? <DialogContent>
                    <div className='d-flex' style={{ paddingBottom: 30 }}>
                        <img src={Image} alt="" style={{ paddingRight: "20px", height: 48 }} />
                        <div>
                            <p style={{ marginBottom: 5 }}>Jennifer Lauren</p>
                            <Button sx={{
                                fontSize: 14, color: "#4E4B66", border: "1px solid #CCCCCC", textTransform: "capitalize", "&:hover": {
                                    border: "1px solid #CCCCCC",
                                }
                            }} variant="outlined" onClick={() => { setCounter(4) }} startIcon={<GroupsIcon />} endIcon={<KeyboardArrowRightIcon />}   >
                                Company
                            </Button>
                        </div>
                    </div>
                    <div>
                        <EditorComponent counter={counter} editPost={editPost} placeholder="Have something to say?" onEditorContentChanged={onEditorContentChanged} />
                    </div> 
                                    {/* Applaud MODEL CONTENT */}

                    {counter==2?
                    <div style={{marginTop: "40px"}} >
                        <h4>Template Color</h4>
                        <div style={{marginTop: "20px"}} className='d-flex'>
                            <button style={{backgroundColor: "#2F8F9D"}} className='template-button' ></button>
                            <button style={{backgroundColor: "#FFBD3E"}} className='template-button' ></button>
                            <button style={{backgroundColor: "#7858A6"}} className='template-button' ></button>
                            <button style={{backgroundColor: "#059584"}} className='template-button' ></button>

                        </div>
                    </div>
                    :null}
                                    {/* VOTE MODEL CONTENT */}

                    {counter == 3 ? <div style={{ marginTop: "40px", color: "#14142B" }}>
                        <form >
                            {Array.from(Array(addField)).map((c, index) => {
                                return (
                                    <>
                                        <label>Answer {index + 1}<span style={{ color: "#FF4D4F" }}>*</span></label>
                                        <TextField
                                            onChange={handleOnChange}
                                            key={c}
                                            InputProps={{
                                                endAdornment: (
                                                  <InputAdornment position="end">
                                                 {(index > 1) && <CancelIcon sx={{cursor: "pointer", '&.MuiSvgIcon-fontSizeMedium':{color:"#FF4D4F"}}} onClick={handleClickShowPassword} />} 
                                                  </InputAdornment>
                                                ),
                                              }}
                                            sx={{
                                                marginBottom: "20px",
                                                '& label.Mui-focused': {
                                                    color: '#F78812',
                                                },
                                                '& .MuiInput-underline:after': {
                                                    borderBottomColor: '#F78812',
                                                },
                                                '& .MuiOutlinedInput-root': {
                                                    '& fieldset': {
                                                        borderColor: '#CCCCCC',
                                                    },
                                                    '&:hover fieldset': {
                                                        borderColor: '#F78812',
                                                    },
                                                    '&.Mui-focused fieldset': {
                                                        borderColor: '#F78812',
                                                    },
                                                },
                                            }}
                                            fullWidth id="outlined-basic" variant="outlined" />

                                    </>
                                );
                            })}

                            <Button onClick={addFieldHandler} sx={{ color: "#F78812", textTransform: "capitalize", fontSize: "14", fontWeight: "600", margin: "20px 0px" }} variant="text" startIcon={<AddCircleIcon />}>Add answer</Button>
                        </form>
                        <p style={{ fontSize: "12px", }}>This poll will end in 14 days</p>

                    </div>
                        : null}
                    <div className='d-flex justify-end' style={{ paddingTop: 50 }}>
                        <Button
                            onClick={() => { setCounter(5); setToggle(true) }}
                            sx={{
                                color: "#A9A9A9", background: "#F1EFF2", padding: "13px 35px", fontWeight: 600, marginRight: { xs: "10px", md: "20px" }, fontSize: 16, textTransform: "capitalize", '&:hover': {
                                    backgroundColor: '#F1EFF2',
                                },
                            }} startIcon={<RemoveRedEyeIcon />} className=''>Preview</Button>
                        <Button sx={{
                           '&:hover': {
                                backgroundColor: '#F78812',
                            },
                        }} onClick={() => { props.setAddData(true); setToggle(false) }} className='btn-secondary post-button-style'>Post</Button>
                    </div>
                </DialogContent>

                    // RENDERING GROUP CHECKBOX MODEL

                    : (counter === 4) ?
                        <DialogContent>
                            <div style={{marginTop: "20px"}}>
                                <TextField
                                    fullWidth
                                    placeholder="Search"
                                    id="outlined-multiline-static"
                                    multiline
                                />
                                <div>
                                    <FormControlLabel
                                        label="All Company"
                                        control={
                                            <Checkbox
                                                sx={{
                                                    color: "#4C0027",
                                                    '&.Mui-checked': {
                                                        color: "#4C0027",
                                                    },
                                                    '&.MuiCheckbox-indeterminate': {
                                                        color: "#4C0027",
                                                    },
                                                }}
                                                checked={checked[0] && checked[1]}
                                                indeterminate={checked[0] !== checked[1]}
                                                onChange={handleChange1}
                                            />
                                        }
                                    />
                                    {children}
                                </div>
                                <div className='d-flex justify-end' style={{ paddingTop: 50 }}>
                                    <Button sx={{
                                        color: "#A9A9A9", background: "#F1EFF2", padding: "13px 35px", fontWeight: 600, textTransform: "capitalize", fontSize: 16, marginRight: { xs: "10px", md: "20px" }, '&:hover': {
                                            backgroundColor: '#F1EFF2',
                                        },
                                    }} onClick={() => { setCounter(previousCounterValue.current) }} className=''>Cancel</Button>
                                    <Button sx={{
                                     '&:hover': {
                                            backgroundColor: '#F78812',
                                        },
                                    }} onClick={() => { setCounter(previousCounterValue.current) }} className='btn-secondary post-button-style'>Apply</Button>
                                </div>
                            </div>
                        </DialogContent> :
                        counter == 5 ?
                            <DialogContent className='preview-post'>
                                {editorHtmlValue ?
                                    <ReactMarkdown>{editorMarkdownValue}</ReactMarkdown> :
                                    <div className='d-flex align-center justify-center'>
                                        <p>Please Add Something To Preview</p>
                                    </div>
                                }

                            </DialogContent>
                            : null
                }
            </Dialog>

        </>
    )
}

export default PostModel;